import styled from 'styled-components'
import { Button } from 'antd'

export const Wrapper = styled.div`
  padding: 24px;
  background: #f0f2f5;
  min-height: 100vh;
`

export const Actions = styled.div`
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`

export const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const TableWrapper = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02);
  
  .ant-table-wrapper {
    .ant-table {
      font-size: 14px;
    }
    
    .ant-table-thead > tr > th {
      background: #fafafa;
      font-weight: 600;
    }
    
    .ant-table-tbody > tr > td {
      padding: 12px 16px;
    }
    
    .ant-table-expand-icon-cell {
      padding: 12px 8px 12px 16px !important;
    }
    
    .ant-table-row-expand-icon {
      color: #1890ff;
      cursor: pointer;
      transition: all 0.3s;
      
      &:hover {
        color: #40a9ff;
      }
    }
  }
`

export const StatusTag = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  
  &.active {
    background: #f6ffed;
    color: #52c41a;
    border: 1px solid #b7eb8f;
  }
  
  &.inactive {
    background: #fff1f0;
    color: #ff4d4f;
    border: 1px solid #ffccc7;
  }
  
  &.scheduled {
    background: #fff7e6;
    color: #fa8c16;
    border: 1px solid #ffd591;
  }
`

export const ActionButtons = styled.div`
  display: flex;
  gap: 4px;
  
  .ant-btn-link {
    padding: 8px 12px;
    height: auto;
    min-width: 32px;
    min-height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: all 0.2s;
    
    &:hover {
      background-color: #f0f0f0;
    }
    
    &.ant-btn-dangerous:hover {
      background-color: #fff2f0;
    }
    
    .anticon {
      font-size: 16px;
    }
  }
`